<script>
  import ButtonContainer from "@helpers/ButtonContainer.svelte";

  // REACH FIXME: Do real research to get actual #s, this is just from Ballotpedia
  // https://docs.google.com/spreadsheets/d/1s1lNbneceXB5jLFaThxKWHzmshfnV6lebsEe1uQclgc/edit?usp=sharing
  import data from "@data/otherCities.json";

  let selectedXCol = "budget";
  let buttonText = "Per-Citizen";

  let height = 400;
  $: margin =
    $viewport.width < 468
      ? { top: 40, right: 85, bottom: 20, left: 0 }
      : { top: 20, right: 75, bottom: 20, left: 0 };

  let width;
  $: w = width - margin.left - margin.right;

  import { scaleLinear, scaleBand } from "d3-scale";
  import { max } from "d3-array";
  import { format } from "d3-format";

  const suffix = (num) => {
    if (selectedXCol == "budget") {
      return `${num / 1000000000}B`;
    } else {
      return `${format(",")(num)}`;
    }
  };

  $: xScale = scaleLinear()
    .domain([0, max(data, (d) => +d[selectedXCol])])
    .range([margin.left, w - margin.right]);

  let yDomain = data
    .sort((a, b) => a["budget"] - b["budget"])
    .map((d) => d.city);

  let yDomainPerPerson = data
    .sort((a, b) => a["per_citizen"] - b["per_citizen"])
    .map((d) => d.city);

  $: yScale = scaleBand()
    .domain(yDomain)
    .range([height - margin.top, margin.bottom])
    .padding(0.1);

  $: yScalePerPerson = scaleBand()
    .domain(yDomainPerPerson)
    .range([height - margin.top, margin.bottom])
    .padding(0.1);

  // import { tweened } from "@helpers/tweenedStaggered.js";
  import { tweened } from "svelte/motion";
  import { cubicInOut } from "svelte/easing";

  const tweenOptions = {
    duration: 500,
    delay: 350,
    ease: cubicInOut,
  };

  $: tweenedYPositions = tweened(
    data.map((d) => yScale(d.city)),
    tweenOptions
  );

  const toggle = () => {
    if (selectedXCol == "budget") {
      selectedXCol = "per_citizen";
      buttonText = "Total";
      tweenedYPositions.set(data.map((d) => yScalePerPerson(d.city)));
    } else {
      selectedXCol = "budget";
      buttonText = "Per-Citizen";
      tweenedYPositions.set(data.map((d) => yScale(d.city)));
    }
  };

  import viewport from "@stores/viewport.js";
  import { fade, fly } from "svelte/transition";
</script>

<div class="chart-container" bind:clientWidth={width}>
  <ButtonContainer
    styles={$viewport.width < 368
      ? "position: absolute; bottom: 50px; right: 0; transform: scale(.65) translateX(20%);"
      : $viewport.width < 468
      ? "position: absolute; bottom: 60px; right: 0; transform: scale(.75) translateX(10%);"
      : "position: absolute; bottom: 100px; right: 20px;"}
    fontSize="1rem"
    ><button on:click={toggle}>See {buttonText} Budget</button></ButtonContainer
  >
  <svg {width} {height}>
    <!-- CHART TITLE -->
    <text
      x={$viewport.width < 468 ? width - 10 : width - 20}
      y={$viewport.width < 468 ? height - 25 : height - 50}
      height="1em"
      class="title">Top Budgets</text
    >
    {#each data as d, i}
      <rect
        class="bar"
        x={margin.left}
        width={xScale(+d[selectedXCol])}
        y={$tweenedYPositions[i]}
        height={yScale.bandwidth()}
        fill={d.city === "Houston"
          ? "var(--accent-color)"
          : "rgba(var(--accent-color-rgb), 0.5)"}
      />
      {#key selectedXCol}
        {#if $viewport.width > 868}
          <text
            in:fade
            out:fly
            x={xScale(+d[selectedXCol]) + margin.left}
            dx={-6}
            y={$tweenedYPositions[i]}
            dy={yScale.bandwidth() / 2 + 1}
            stroke="rgba(0,0,0,.3)"
            fill="none"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="in-bar background"
            font-family="var(--font-sans)">${suffix(+d[selectedXCol])}</text
          >
          <text
            in:fade
            out:fly
            x={xScale(+d[selectedXCol]) + margin.left}
            dx={-6}
            y={$tweenedYPositions[i]}
            dy={yScale.bandwidth() / 2 + 1}
            fill="white"
            class="in-bar"
            font-family="var(--font-sans)">${suffix(+d[selectedXCol])}</text
          >
          <text
            in:fade
            out:fly
            x={xScale(+d[selectedXCol]) + margin.left}
            dx={6}
            y={$tweenedYPositions[i]}
            dy={yScale.bandwidth() / 2 + 1}
            fill={d.city === "Houston" ? "black" : "var(--accent-color)"}
            class="out-of-bar"
            font-size="1.25rem"
            font-family="var(--font-serif)">{d.city}</text
          >
        {:else}
          <text
            in:fade
            out:fly
            x={xScale(+d[selectedXCol]) + margin.left}
            dx={6}
            y={$tweenedYPositions[i]}
            dy={yScale.bandwidth() / 2 + 1}
            fill={"black"}
            class={"out-of-bar"}
            font-family="var(--font-serif)"
            >{d.city}: ${suffix(+d[selectedXCol])}</text
          >
        {/if}
      {/key}
    {/each}
  </svg>
</div>

<style>
  .bar {
    transition: width 400ms ease;
  }
  .chart-container {
    width: 100%;
    max-width: 1168px;
    height: 400px;
    border-radius: 0.25rem;
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.15);
    background: var(--primary-color-base);
    margin-top: 1rem;
  }

  text {
    dominant-baseline: middle;
    /* animation-duration: 1000ms;
    animation-name: slidein;
    animation-timing-function: ease; */
  }

  /* @keyframes slidein {
    from {
      x: margin-left;
    }

    to {
      x: xScale(+ d[selectedXCol]) + margin-left;
    }
  } */

  .in-bar {
    text-anchor: end;
  }

  .out-of-bar {
    font-weight: 300;
    text-anchor: start;
  }

  .title {
    font-size: 3rem;
    font-weight: 800;
    text-anchor: end;
    font-family: var(--font-serif);
    fill: var(--accent-color);
  }

  @media screen and (max-width: 468px) {
    .title {
      font-size: 2.25rem;
    }

    @media screen and (max-width: 368px) {
      .title {
        font-size: 2rem;
      }
    }
  }
</style>
